import React from 'react'
import OrdersTableList from "./OrdersTableList"
import CMSApi from '../../utils/opsloth_cms_service_api'
import { Box, Button, CardActions, Chip, Collapse, FormControlLabel, IconButton, InputAdornment, Paper, Switch, TextField, Typography } from '@mui/material'
import select_items from '../../utils/select_items'
import SearchIcon from '@mui/icons-material/Search';
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import RefreshIcon from '@mui/icons-material/Refresh'
import { set } from 'mongoose'
import { Category } from '@mui/icons-material'

function OrdersTableDiv(props: any) {
  const [initPageLimit] = React.useState(20)
  const [pageLimit, setPageLimit] = React.useState(initPageLimit)
  const [currentPage, setCurrentPage] = React.useState(0)
  const [orderBy, setOrderBy] = React.useState<string>('createdAt')
  const [order, setOrder] = React.useState<'desc' | 'asc'>('desc')
  const [data, setData] = React.useState<any[]>([])
  const [customers, setCustomers] = React.useState([])
  const [showAllOrders, setShowAllOrders] = React.useState(false)
  const dataModel = new CMSApi(props.schema.TABLE.name)
  const customersModel = new CMSApi("customers")
  const [ordersTypeFilter, setOrdersTypeFilter] = React.useState<any[]>([])
  const [unpayBalcanceFilterClicked, setUnpayBalcanceFilterClicked] = React.useState(false)
  const [domin_store_opsloth_filter_clicked, setDomin_store_opsloth_filter_clicked] = React.useState(false)
  const [domin_jumbotang_filter_clicked, setDomin_jumbotang_filter_clicked] = React.useState(false)
  const [domin_starraykuji_filter_clicked, setDomin_starraykuji_filter_clicked] = React.useState(false)

  const [filterCollapse, setFilterCollapse] = React.useState(false)
  const [searchKeyword, setSearchKeyword] = React.useState('')
  const [logisticsStatusSelected, setLogisticsStatusSelected] = React.useState<string[]>([])
  const [customersSelected, setCustomersSelected] = React.useState<string[]>([])

  const [orderStatusStatusSelected, setOrderStatusStatusSelected] = React.useState<string[]>([])

  const [doubleCheckedSelected, setDoubleCheckedSelected] = React.useState<string[]>([])



  const generateFilter = () => {
    let orderStatusStatusSelectedKage = JSON.parse(JSON.stringify(orderStatusStatusSelected))
    orderStatusStatusSelectedKage.splice(orderStatusStatusSelectedKage.indexOf('定金已付'), 1)
    orderStatusStatusSelectedKage.splice(orderStatusStatusSelectedKage.indexOf('尾款已付'), 1)
    orderStatusStatusSelectedKage.splice(orderStatusStatusSelectedKage.indexOf('定金未付'), 1)
    orderStatusStatusSelectedKage.splice(orderStatusStatusSelectedKage.indexOf('尾款未付'), 1)

    let deposit_cny_filter = undefined
    let balance_cny_filter = undefined

    if (orderStatusStatusSelected.indexOf('定金已付') >= 0 && orderStatusStatusSelected.indexOf('定金未付') >= 0) {
      deposit_cny_filter = { $gt: 0, $eq: 0 }
    } else if (orderStatusStatusSelected.indexOf('尾款已付') >= 0 && orderStatusStatusSelected.indexOf('尾款未付') >= 0) {
      balance_cny_filter = { $gt: 0, $eq: 0 }
    } else if (orderStatusStatusSelected.indexOf('定金已付') >= 0) {
      deposit_cny_filter = { $gt: 0 }
    } else if (orderStatusStatusSelected.indexOf('尾款已付') >= 0) {
      balance_cny_filter = { $gt: 0 }
    } else if (orderStatusStatusSelected.indexOf('定金未付') >= 0) {
      deposit_cny_filter = { $eq: 0 }
    } else if (orderStatusStatusSelected.indexOf('尾款未付') >= 0) {
      balance_cny_filter = { $eq: 0 }
    }

    let double_checked_filter = {}
    if (doubleCheckedSelected.length == 1 && doubleCheckedSelected[0] == "已核对") {
      double_checked_filter = "已核对"
    }

    if (doubleCheckedSelected.length == 1 && doubleCheckedSelected[0] == "未核对") {
      double_checked_filter = { $ne: "已核对" }
    }

    if (doubleCheckedSelected.length == 2) {
      double_checked_filter = { $in: doubleCheckedSelected }
    }
    let filter: any = {
      category: { $regex: props.category.split("-")[0] },
      $or: [{ company: { $regex: searchKeyword } }, { "products.product_code": searchKeyword }, { "out_trade_no": { $regex: searchKeyword } }],
      deposit_cny: deposit_cny_filter,
      balance_cny: balance_cny_filter,
      cargo_sent: logisticsStatusSelected.length > 0 ? { $in: logisticsStatusSelected } : undefined,
      double_checked: doubleCheckedSelected.length > 0 ? double_checked_filter : undefined,
      company: customersSelected.length > 0 ? { $in: customersSelected } : undefined,
      order_status: orderStatusStatusSelectedKage.length > 0 ? { $in: orderStatusStatusSelectedKage } : undefined,
      deleted: showAllOrders ? undefined : { $ne: true },
    }
    if (unpayBalcanceFilterClicked) {
      filter.order_type = {"$regex":"预售"}
      filter['products.can_pay_balance'] = "可补款"
    }

    if (domin_store_opsloth_filter_clicked) {
      filter.domin = "https://store.opsloth.com/OrderConfirm"
    }

    if (domin_jumbotang_filter_clicked) {
      filter.domin = "https://jumbotang.com/OrderConfirm"
    }

    if (domin_starraykuji_filter_clicked) {
      filter.domin = "https://starraykuji.com/OrderConfirm"
    }

    if (ordersTypeFilter.length > 0 && ordersTypeFilter.length <= 3) {
      filter.order_type = { $in: ordersTypeFilter }
    }
    return filter
  }

  const getCustomers = async () => {
    const res: any = await customersModel
      .setFilter({ deleted: { $ne: true } })
      .setField("company")
      .setOptions({
        sort: "company"
      }).get()
    setCustomers(res.data)
  }

  const getData = async () => {
    const res: any = await dataModel
      .setFilter(generateFilter())
      .setOptions({
        skip: currentPage * pageLimit,
        limit: pageLimit,
        sort: (order === 'desc' ? '-' : '+') + orderBy
      }).get()
    setData(res.data)
  }

  const handlePrevPageClick = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1)
    }
  }

  const handleNextPageClick = () => {
    if (data.length == pageLimit) {
      setCurrentPage(currentPage + 1)
    } else {
      props.newAlert('已是最后一页', 'warning')
    }
  }

  const handleAllOrdersChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentPage(0)
    setShowAllOrders(event.target.checked)
  }

  const handleOrderTypeFilterClick = (label: string) => {
    if (label == "全部") {
      if (ordersTypeFilter.length == 3) {
        setOrdersTypeFilter([])
      } else {
        setOrdersTypeFilter(["现货", "预售", "尾款"])
      }
    } else {
      setOrdersTypeFilter(ordersTypeFilter => {
        if (ordersTypeFilter.indexOf(label) >= 0) {
          return ordersTypeFilter.filter(item => item != label)
        } else {
          return [...ordersTypeFilter, label]
        }
      })
    }
  }

  const handleButtonFilterClick = (event: any) => {
    const buttonName = event.target.dataset.buttonname;
    const stateMap: any = {
      unpayBalcanceFilter: unpayBalcanceFilterClicked,
      domin_store_opsloth_filter: domin_store_opsloth_filter_clicked,
      domin_jumbotang_filter: domin_jumbotang_filter_clicked,
      domin_starraykuji_filter: domin_starraykuji_filter_clicked,
    };

    const setterMap: any = {
      unpayBalcanceFilter: setUnpayBalcanceFilterClicked,
      domin_store_opsloth_filter: setDomin_store_opsloth_filter_clicked,
      domin_jumbotang_filter: setDomin_jumbotang_filter_clicked,
      domin_starraykuji_filter: setDomin_starraykuji_filter_clicked,
    };

    Object.keys(stateMap).forEach((key: any) => {
      const newValue = (key === buttonName) ? !stateMap[key] : false;
      setterMap[key](newValue);
    });
  }

  React.useEffect(() => {
    getData()
  }, [
    order,
    orderBy,
    currentPage,
    showAllOrders,
    unpayBalcanceFilterClicked,
    domin_store_opsloth_filter_clicked,
    domin_jumbotang_filter_clicked,
    domin_starraykuji_filter_clicked,
    ordersTypeFilter
  ])

  React.useEffect(() => {
    getCustomers()
  }, [])

  React.useEffect(() => {
    setCurrentPage(0)
    getData()
  }, [props.reloadArg])

  return (
    <Box>
      <Box
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Box>
          <Button
            onClick={handlePrevPageClick}
          >上一页</Button>
          <Button
            variant="text"
            sx={{ mx: 1 }}
          >{currentPage + 1}</Button>
          <Button
            onClick={handleNextPageClick}
          >下一页</Button>
        </Box>
        <Box>
          <FormControlLabel
            label="显示全部订单"
            control={
              <Switch
                onChange={handleAllOrdersChange}
              />
            } />
        </Box>
      </Box>


      <Paper
        sx={{ mb: 1 }}
      >
        <CardActions>
          <TextField
            fullWidth
            size='small'
            placeholder="输入商家名称"
            onInput={(event: any) => { setSearchKeyword(event.target.value.replace(/[\#\%\&\*\\\(\)\[\]]/g, '')) }}
            onKeyDown={(event: any) => { if (event.keyCode === 13) { getData(); setCurrentPage(0) } }}
            value={searchKeyword}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <IconButton
            sx={{ mx: 1 }}
            size='large'
            onClick={() => { setFilterCollapse(!filterCollapse) }}
          >
            {filterCollapse ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </CardActions >


        <Box sx={{ m: 1, display: 'flex', gap: 1 }}>
          {/* <Chip onClick={() => handleOrderTypeFilterClick("全部")} sx={{ cursor: 'pointer', px: 1 }} color={ordersTypeFilter.length == 3 ? 'primary' : 'default'} label="全部" /> */}
          <Chip onClick={() => handleOrderTypeFilterClick("现货")} sx={{ cursor: 'pointer', px: 1 }} color={ordersTypeFilter.indexOf("现货") >= 0 ? 'primary' : 'default'} label="现货" />
          <Chip onClick={() => handleOrderTypeFilterClick("预售")} sx={{ cursor: 'pointer', px: 1 }} color={ordersTypeFilter.indexOf("预售") >= 0 ? 'primary' : 'default'} label="预售" />
          <Chip onClick={() => handleOrderTypeFilterClick("尾款")} sx={{ cursor: 'pointer', px: 1 }} color={ordersTypeFilter.indexOf("尾款") >= 0 ? 'primary' : 'default'} label="尾款" />
        </Box>
        <Box>
          <Button onClick={handleButtonFilterClick} data-buttonname="unpayBalcanceFilter" variant={unpayBalcanceFilterClicked ? 'contained' : 'outlined'} sx={{ mx: 1 }}>查看未补款订单</Button>
          <Button onClick={handleButtonFilterClick} data-buttonname="domin_store_opsloth_filter" variant={domin_store_opsloth_filter_clicked ? 'contained' : 'outlined'} sx={{ mx: 1 }}>查看 opsloth 订单</Button>
          <Button onClick={handleButtonFilterClick} data-buttonname="domin_jumbotang_filter" variant={domin_jumbotang_filter_clicked ? 'contained' : 'outlined'} sx={{ mx: 1 }}>查看 jumbotang 订单</Button>
          <Button onClick={handleButtonFilterClick} data-buttonname="domin_starraykuji_filter" variant={domin_starraykuji_filter_clicked ? 'contained' : 'outlined'} sx={{ mx: 1 }}>查看 starraykuji 订单</Button>
        </Box>

        <Collapse in={filterCollapse} timeout="auto" sx={{ px: 1, py: .5 }}>
          {/* <Typography variant='body2'>商家选择</Typography>
          <Box sx={{ mx: 2 }}>
            {
              customers.map((customer: any) => {
                return (
                  <Chip
                    key={customer.company}
                    clickable={false}
                    onClick={() => {
                      if (customersSelected.indexOf(customer.company) == -1) {
                        customersSelected.push(customer.company)
                      } else {
                        customersSelected.splice(customersSelected.indexOf(customer.company), 1)
                      }
                      setCustomersSelected([...customersSelected])
                    }}
                    color={customersSelected.indexOf(customer.company) >= 0 ? 'primary' : 'default'}
                    label={customer.company}
                    size="small"
                    sx={{ m: .4, cursor: 'pointer' }}
                  />
                )
              })
            }
          </Box> */}
          <Typography variant='body2'>物流状态选择</Typography>
          <Box sx={{ mx: 2 }}>
            {
              select_items['logistics_status'].map(item => {
                return (
                  <Chip
                    key={item.label}
                    clickable={false}
                    onClick={() => {
                      if (logisticsStatusSelected.indexOf(item.label) == -1) {
                        logisticsStatusSelected.push(item.label)
                      } else {
                        logisticsStatusSelected.splice(logisticsStatusSelected.indexOf(item.label), 1)
                      }
                      setLogisticsStatusSelected([...logisticsStatusSelected])
                    }}
                    color={logisticsStatusSelected.indexOf(item.label) >= 0 ? 'primary' : 'default'}
                    label={item.label}
                    size="small"
                    sx={{ m: .4, cursor: 'pointer' }}
                  />
                )
              })
            }
          </Box>
          <Typography variant='body2'>订单状态选择</Typography>
          <Box sx={{ mx: 2 }}>
            {
              select_items['order_status'].map(item => {
                return (
                  <Chip
                    key={item.label}
                    clickable={false}
                    onClick={() => {
                      if (orderStatusStatusSelected.indexOf(item.label) == -1) {
                        orderStatusStatusSelected.push(item.label)
                      } else {
                        orderStatusStatusSelected.splice(orderStatusStatusSelected.indexOf(item.label), 1)
                      }
                      setOrderStatusStatusSelected([...orderStatusStatusSelected])
                    }}
                    color={orderStatusStatusSelected.indexOf(item.label) >= 0 ? 'primary' : 'default'}
                    label={item.label}
                    size="small"
                    sx={{ m: .4, cursor: 'pointer' }}
                  />
                )
              })
            }
          </Box>
          <Typography variant='body2'>是否检查选择（注意旧订单无检查选项）</Typography>
          <Box sx={{ mx: 2 }}>
            {
              select_items['double_checked'].map(item => {
                return (
                  <Chip
                    key={item.label}
                    clickable={false}
                    onClick={() => {
                      if (doubleCheckedSelected.indexOf(item.label) == -1) {
                        doubleCheckedSelected.push(item.label)
                      } else {
                        doubleCheckedSelected.splice(doubleCheckedSelected.indexOf(item.label), 1)
                      }
                      setDoubleCheckedSelected([...doubleCheckedSelected])
                    }}
                    color={doubleCheckedSelected.indexOf(item.label) >= 0 ? 'primary' : 'default'}
                    label={item.label}
                    size="small"
                    sx={{ m: .4, cursor: 'pointer' }}
                  />
                )
              })
            }
          </Box>
          {
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                onClick={() => {
                  setSearchKeyword('')
                  setLogisticsStatusSelected([])
                  setOrderStatusStatusSelected([])
                  setCustomersSelected([])
                  setDoubleCheckedSelected([])
                }}
                variant='contained'
                color='warning'
                sx={{ m: 1, position: 'relative', right: 0 }}
              >重置过滤</Button>
              <Button
                onClick={async () => {
                  getData()
                  setCurrentPage(0)
                }}
                variant='contained'
                sx={{ m: 1, mr: 8, position: 'relative', right: 0 }}
              >搜索</Button>
            </Box>
          }
        </Collapse>
      </Paper>

      <OrdersTableList
        newAlert={props.newAlert}
        schema={props.schema}
        category={props.category}
        array={data}
        getttData={getData}
      ></OrdersTableList>

      <Box>
        <Button
          onClick={handlePrevPageClick}
        >上一页</Button>
        <Button
          variant="text"
        >{currentPage + 1}</Button>
        <Button
          onClick={handleNextPageClick}
        >下一页</Button>
      </Box>
    </Box>
  )
}

export default OrdersTableDiv